import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdType } from 'src/components/visibility/types';

export type SortBy = 'Freq.' | 'Position' | 'Price';
export type SortDirection = 'asc' | 'desc';

export interface AdsUiState {
  adType: AdType;
  searchQuery: string;
  sortBy: SortBy;
  sortDirection: SortDirection;
  hasPla: boolean;
}

const initialState: AdsUiState = {
  adType: 'ALL',
  searchQuery: '',
  sortBy: 'Freq.',
  sortDirection: 'desc',
  hasPla: false,
};

const adsUiSlice = createSlice({
  name: 'visibilityAdsUi',
  initialState,
  reducers: {
    setAdType(state, action: PayloadAction<AdType>) {
      state.adType = action.payload;
    },

    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },

    setSortBy(state, action: PayloadAction<SortBy>) {
      state.sortBy = action.payload;
    },

    setSortDirection(state, action: PayloadAction<SortDirection>) {
      state.sortDirection = action.payload;
    },

    setHasPla(state, action: PayloadAction<boolean>) {
      state.hasPla = action.payload;
    },

    resetAdsUi(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setAdType,
  setSearchQuery,
  setSortBy,
  setSortDirection,
  setHasPla,
  resetAdsUi,
} = adsUiSlice.actions;

export default adsUiSlice.reducer;